/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemFull,
  LineItemFullOptional,
  LineItemFullMetaI,
  LineItemFullTrackedI,
} from "./line-item-full";
import { LineItemFullTracked, LineItemFullMeta } from "./line-item-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderBase,
  OrderBaseOptional,
  OrderBaseMetaI,
  OrderBaseTrackedI,
} from "./order-base";
import { OrderBaseTracked, OrderBaseMeta } from "./order-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderPaymentBase,
  OrderPaymentBaseOptional,
  OrderPaymentBaseMetaI,
  OrderPaymentBaseTrackedI,
} from "./order-payment-base";
import {
  OrderPaymentBaseTracked,
  OrderPaymentBaseMeta,
} from "./order-payment-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderRef,
  OrderRefOptional,
  OrderRefMetaI,
  OrderRefTrackedI,
} from "./order-ref";
import { OrderRefTracked, OrderRefMeta } from "./order-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderSource,
  OrderSourceOptional,
  OrderSourceMetaI,
  OrderSourceTrackedI,
} from "./order-source";
import { OrderSourceTracked, OrderSourceMeta } from "./order-source";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderStateNew,
  OrderStateNewOptional,
  OrderStateNewMetaI,
  OrderStateNewTrackedI,
} from "./order-state-new";
import { OrderStateNewTracked, OrderStateNewMeta } from "./order-state-new";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UserRef,
  UserRefOptional,
  UserRefMetaI,
  UserRefTrackedI,
} from "./user-ref";
import { UserRefTracked, UserRefMeta } from "./user-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithOptionalPersonRef,
  WithOptionalPersonRefOptional,
  WithOptionalPersonRefMetaI,
  WithOptionalPersonRefTrackedI,
} from "./with-optional-person-ref";
import {
  WithOptionalPersonRefTracked,
  WithOptionalPersonRefMeta,
} from "./with-optional-person-ref";

/**
 *
 * @export
 * @interface OrderFull
 */
export interface OrderFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof OrderFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderFull
   */
  assignId?: number;
  /**
   *
   * @type {OrderSource}
   * @memberof OrderFull
   */
  orderSource?: OrderSource;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderFull
   */
  amountSubtotalCents?: number;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderFull
   */
  amountDiscountsCents?: number;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderFull
   */
  amountTaxesCents?: number;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderFull
   */
  amountTotalCents?: number;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderFull
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderFull
   */
  version?: number;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderFull
   */
  orderStatus?: OrderStateNew;
  /**
   *
   * @type {string}
   * @memberof OrderFull
   */
  squareOrderId?: string;
  /**
   *
   * @type {PersonRef}
   * @memberof OrderFull
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {Array<LineItemFull>}
   * @memberof OrderFull
   */
  lineItems?: LineItemFullOptional[];
  /**
   *
   * @type {Array<OrderPaymentBase>}
   * @memberof OrderFull
   */
  orderPayments?: OrderPaymentBaseOptional[];
  /**
   *
   * @type {UserRef}
   * @memberof OrderFull
   */
  user?: UserRefOptional;
}

export interface OrderFull
  extends
    OrderFullOptional,
    Deletable,
    OrderBase,
    OrderRef,
    WithOptionalPersonRef {
  /**
   *
   * @type {boolean}
   * @memberof OrderFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderFull
   */
  assignId: number;
  /**
   *
   * @type {OrderSource}
   * @memberof OrderFull
   */
  orderSource?: OrderSource;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderFull
   */
  amountSubtotalCents?: number;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderFull
   */
  amountDiscountsCents?: number;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderFull
   */
  amountTaxesCents?: number;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderFull
   */
  amountTotalCents?: number;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderFull
   */
  amountPaidCents?: number;
  /**
   *
   * @type {number}
   * @memberof OrderFull
   */
  version: number;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderFull
   */
  orderStatus?: OrderStateNew;
  /**
   *
   * @type {string}
   * @memberof OrderFull
   */
  squareOrderId?: string;
  /**
   *
   * @type {PersonRef}
   * @memberof OrderFull
   */
  personId?: PersonRef;
  /**
   *
   * @type {Array<LineItemFull>}
   * @memberof OrderFull
   */
  lineItems?: LineItemFull[];
  /**
   *
   * @type {Array<OrderPaymentBase>}
   * @memberof OrderFull
   */
  orderPayments?: OrderPaymentBase[];
  /**
   *
   * @type {UserRef}
   * @memberof OrderFull
   */
  user?: UserRef;
}

export interface OrderFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof OrderFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {OrderSource}
   * @memberof OrderFull
   */
  orderSource?: OrderSource;
  orderSourceIsSet: boolean;
  /**
   * Total of all items before discounts and taxes
   * @type {number}
   * @memberof OrderFull
   */
  amountSubtotalCents?: number;
  amountSubtotalCentsIsSet: boolean;
  /**
   * Total of all discounts applied
   * @type {number}
   * @memberof OrderFull
   */
  amountDiscountsCents?: number;
  amountDiscountsCentsIsSet: boolean;
  /**
   * Total of all taxes applied
   * @type {number}
   * @memberof OrderFull
   */
  amountTaxesCents?: number;
  amountTaxesCentsIsSet: boolean;
  /**
   * Total of all items with discounts and taxes
   * @type {number}
   * @memberof OrderFull
   */
  amountTotalCents?: number;
  amountTotalCentsIsSet: boolean;
  /**
   * Total of all successful payments
   * @type {number}
   * @memberof OrderFull
   */
  amountPaidCents?: number;
  amountPaidCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderFull
   */
  version?: number;
  versionIsSet: boolean;
  /**
   *
   * @type {OrderStateNew}
   * @memberof OrderFull
   */
  orderStatus?: OrderStateNew;
  orderStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderFull
   */
  squareOrderId?: string;
  squareOrderIdIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof OrderFull
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {Array<LineItemFull>}
   * @memberof OrderFull
   */
  lineItems?: LineItemFullTrackedI[];
  lineItemsIsSet: boolean;
  /**
   *
   * @type {Array<OrderPaymentBase>}
   * @memberof OrderFull
   */
  orderPayments?: OrderPaymentBaseTrackedI[];
  orderPaymentsIsSet: boolean;
  /**
   *
   * @type {UserRef}
   * @memberof OrderFull
   */
  user?: UserRefTrackedI;
  userIsSet: boolean;
}

transformDatesMap.set("OrderFull", function (model: OrderFull) {
  const transformDatespersonId = transformDatesMap.get("PersonRef");
  if (transformDatespersonId && model.personId) {
    transformDatespersonId(model.personId);
  }
  const transformDateslineItems = transformDatesMap.get("LineItemFull");
  if (transformDateslineItems) {
    model.lineItems?.forEach((sub) => {
      transformDateslineItems(sub);
    });
  }
  const transformDatesorderPayments = transformDatesMap.get("OrderPaymentBase");
  if (transformDatesorderPayments) {
    model.orderPayments?.forEach((sub) => {
      transformDatesorderPayments(sub);
    });
  }
  const transformDatesuser = transformDatesMap.get("UserRef");
  if (transformDatesuser && model.user) {
    transformDatesuser(model.user);
  }
});

export type OrderFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  orderSource: PropertyMeta<OrderSourceMetaI>;
  //isDate: false
  //isDatetime: false
  amountSubtotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountDiscountsCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTaxesCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  version: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  orderStatus: PropertyMeta<OrderStateNewMetaI>;
  //isDate: false
  //isDatetime: false
  squareOrderId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  lineItems: PropertyMeta<LineItemFullMetaI>;
  //isDate: false
  //isDatetime: false
  orderPayments: PropertyMeta<OrderPaymentBaseMetaI>;
  //isDate: false
  //isDatetime: false
  user: PropertyMeta<UserRefMetaI>;
}>;

export var OrderFullMeta: OrderFullMetaI = {} as OrderFullMetaI;
OrderFullMeta = typeMeta("OrderFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  orderSource: propertyMeta(
    "orderSource",
    false,
    false,
    false,
    OrderSourceMeta,
  ),
  amountSubtotalCents: propertyMeta(
    "amountSubtotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountDiscountsCents: propertyMeta(
    "amountDiscountsCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTaxesCents: propertyMeta(
    "amountTaxesCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTotalCents: propertyMeta(
    "amountTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPaidCents: propertyMeta(
    "amountPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  version: propertyMeta("version", false, true, false, MetaTypesBase.number),
  orderStatus: propertyMeta(
    "orderStatus",
    false,
    false,
    false,
    OrderStateNewMeta,
  ),
  squareOrderId: propertyMeta(
    "squareOrderId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  personId: propertyMeta("personId", false, false, false, PersonRefMeta),
  lineItems: propertyMeta("lineItems", true, false, false, LineItemFullMeta),
  orderPayments: propertyMeta(
    "orderPayments",
    true,
    false,
    false,
    OrderPaymentBaseMeta,
  ),
  user: propertyMeta("user", false, false, false, UserRefMeta),
});

const metaI = OrderFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([OrderRefMeta]);
  metaI.assignId.inheritedFrom = OrderRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([OrderBaseMeta]);
  metaI.orderSource.inheritedFrom = OrderBaseMeta.orderSource;
  metaI.amountSubtotalCents.inheritedFrom = OrderBaseMeta.amountSubtotalCents;
  metaI.amountDiscountsCents.inheritedFrom = OrderBaseMeta.amountDiscountsCents;
  metaI.amountTaxesCents.inheritedFrom = OrderBaseMeta.amountTaxesCents;
  metaI.amountTotalCents.inheritedFrom = OrderBaseMeta.amountTotalCents;
  metaI.amountPaidCents.inheritedFrom = OrderBaseMeta.amountPaidCents;
  metaI.version.inheritedFrom = OrderBaseMeta.version;
  metaI.orderStatus.inheritedFrom = OrderBaseMeta.orderStatus;
  metaI.squareOrderId.inheritedFrom = OrderBaseMeta.squareOrderId;
  metaI.interfaces = metaI.interfaces.concat([WithOptionalPersonRefMeta]);
  metaI.personId.inheritedFrom = WithOptionalPersonRefMeta.personId;
});

export class OrderFullTracked
  extends DeletableTracked
  implements OrderFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  orderSource__I?: OrderSource = undefined;
  orderSourceIsSet: boolean = false;
  set orderSource(v: undefined | OrderSource) {
    if (v !== undefined) {
      this.orderSource__I = v;
      this.orderSourceIsSet = true;
    } else {
      this.orderSource__I = v || undefined;
      this.orderSourceIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderSource() {
    return this.orderSource__I;
  }
  amountSubtotalCents__I?: number = undefined;
  amountSubtotalCentsIsSet: boolean = false;
  set amountSubtotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountSubtotalCents__I = v;
      this.amountSubtotalCentsIsSet = true;
    } else {
      this.amountSubtotalCents__I = v || undefined;
      this.amountSubtotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountSubtotalCents() {
    return this.amountSubtotalCents__I;
  }
  amountDiscountsCents__I?: number = undefined;
  amountDiscountsCentsIsSet: boolean = false;
  set amountDiscountsCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountDiscountsCents__I = v;
      this.amountDiscountsCentsIsSet = true;
    } else {
      this.amountDiscountsCents__I = v || undefined;
      this.amountDiscountsCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountDiscountsCents() {
    return this.amountDiscountsCents__I;
  }
  amountTaxesCents__I?: number = undefined;
  amountTaxesCentsIsSet: boolean = false;
  set amountTaxesCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTaxesCents__I = v;
      this.amountTaxesCentsIsSet = true;
    } else {
      this.amountTaxesCents__I = v || undefined;
      this.amountTaxesCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTaxesCents() {
    return this.amountTaxesCents__I;
  }
  amountTotalCents__I?: number = undefined;
  amountTotalCentsIsSet: boolean = false;
  set amountTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTotalCents__I = v;
      this.amountTotalCentsIsSet = true;
    } else {
      this.amountTotalCents__I = v || undefined;
      this.amountTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTotalCents() {
    return this.amountTotalCents__I;
  }
  amountPaidCents__I?: number = undefined;
  amountPaidCentsIsSet: boolean = false;
  set amountPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPaidCents__I = v;
      this.amountPaidCentsIsSet = true;
    } else {
      this.amountPaidCents__I = v || undefined;
      this.amountPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPaidCents() {
    return this.amountPaidCents__I;
  }
  version__I?: number = undefined;
  versionIsSet: boolean = false;
  set version(v: undefined | number) {
    if (v !== undefined) {
      this.version__I = v;
      this.versionIsSet = true;
    } else {
      this.version__I = v || undefined;
      this.versionIsSet = true;
    }
    this.changeTracker = true;
  }
  get version() {
    return this.version__I;
  }
  orderStatus__I?: OrderStateNew = undefined;
  orderStatusIsSet: boolean = false;
  set orderStatus(v: undefined | OrderStateNew) {
    if (v !== undefined) {
      this.orderStatus__I = v;
      this.orderStatusIsSet = true;
    } else {
      this.orderStatus__I = v || undefined;
      this.orderStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderStatus() {
    return this.orderStatus__I;
  }
  squareOrderId__I?: string = undefined;
  squareOrderIdIsSet: boolean = false;
  set squareOrderId(v: undefined | string) {
    if (v !== undefined) {
      this.squareOrderId__I = v;
      this.squareOrderIdIsSet = true;
    } else {
      this.squareOrderId__I = v || undefined;
      this.squareOrderIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get squareOrderId() {
    return this.squareOrderId__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  lineItems__I?: LineItemFullTracked[] = undefined;
  lineItemsIsSet: boolean = false;
  set lineItems(v: undefined | LineItemFullTracked[]) {
    if (v !== undefined) {
      this.lineItems__I = v;
      this.lineItemsIsSet = true;
    } else {
      this.lineItems__I = v || undefined;
      this.lineItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get lineItems() {
    return this.lineItems__I;
  }
  orderPayments__I?: OrderPaymentBaseTracked[] = undefined;
  orderPaymentsIsSet: boolean = false;
  set orderPayments(v: undefined | OrderPaymentBaseTracked[]) {
    if (v !== undefined) {
      this.orderPayments__I = v;
      this.orderPaymentsIsSet = true;
    } else {
      this.orderPayments__I = v || undefined;
      this.orderPaymentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get orderPayments() {
    return this.orderPayments__I;
  }
  user__I?: UserRefTracked = undefined;
  userIsSet: boolean = false;
  set user(v: undefined | UserRefTracked) {
    if (v !== undefined) {
      this.user__I = v;
      this.userIsSet = true;
    } else {
      this.user__I = v || undefined;
      this.userIsSet = false;
    }
    this.changeTracker = true;
  }
  get user() {
    return this.user__I;
  }
  constructor(config?: OrderFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personId?.setIds();

    this.lineItems?.forEach((a) => a.setIds());

    this.orderPayments?.forEach((a) => a.setIds());
    this.user?.setIds();
  }
  assignFrom(
    config: OrderFullOptional,
    options?: AssignOptions,
  ): OrderFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.orderSource &&
      this.orderSourceApplyFilter(optionsRequired.filter)
    ) {
      this.orderSource = config.orderSource;
      if (optionsRequired.unassign) this.orderSourceIsSet = false;
      else this.orderSourceIsSet = true;
    }
    if (
      config.amountSubtotalCents &&
      this.amountSubtotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountSubtotalCents = config.amountSubtotalCents;
      if (optionsRequired.unassign) this.amountSubtotalCentsIsSet = false;
      else this.amountSubtotalCentsIsSet = true;
    }
    if (
      config.amountDiscountsCents &&
      this.amountDiscountsCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountDiscountsCents = config.amountDiscountsCents;
      if (optionsRequired.unassign) this.amountDiscountsCentsIsSet = false;
      else this.amountDiscountsCentsIsSet = true;
    }
    if (
      config.amountTaxesCents &&
      this.amountTaxesCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTaxesCents = config.amountTaxesCents;
      if (optionsRequired.unassign) this.amountTaxesCentsIsSet = false;
      else this.amountTaxesCentsIsSet = true;
    }
    if (
      config.amountTotalCents &&
      this.amountTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTotalCents = config.amountTotalCents;
      if (optionsRequired.unassign) this.amountTotalCentsIsSet = false;
      else this.amountTotalCentsIsSet = true;
    }
    if (
      config.amountPaidCents &&
      this.amountPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPaidCents = config.amountPaidCents;
      if (optionsRequired.unassign) this.amountPaidCentsIsSet = false;
      else this.amountPaidCentsIsSet = true;
    }
    if (config.version && this.versionApplyFilter(optionsRequired.filter)) {
      this.version = config.version;
      if (optionsRequired.unassign) this.versionIsSet = false;
      else this.versionIsSet = true;
    }
    if (
      config.orderStatus &&
      this.orderStatusApplyFilter(optionsRequired.filter)
    ) {
      this.orderStatus = config.orderStatus;
      if (optionsRequired.unassign) this.orderStatusIsSet = false;
      else this.orderStatusIsSet = true;
    }
    if (
      config.squareOrderId &&
      this.squareOrderIdApplyFilter(optionsRequired.filter)
    ) {
      this.squareOrderId = config.squareOrderId;
      if (optionsRequired.unassign) this.squareOrderIdIsSet = false;
      else this.squareOrderIdIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (config.lineItems && this.lineItemsApplyFilter(optionsRequired.filter)) {
      this.lineItems = config.lineItems?.map(
        (a) => new LineItemFullTracked(a, options),
      );
      if (optionsRequired.unassign) this.lineItemsIsSet = false;
      else this.lineItemsIsSet = true;
    }
    if (
      config.orderPayments &&
      this.orderPaymentsApplyFilter(optionsRequired.filter)
    ) {
      this.orderPayments = config.orderPayments?.map(
        (a) => new OrderPaymentBaseTracked(a, options),
      );
      if (optionsRequired.unassign) this.orderPaymentsIsSet = false;
      else this.orderPaymentsIsSet = true;
    }
    if (config.user && this.userApplyFilter(optionsRequired.filter)) {
      this.user = new UserRefTracked(config.user, options);
      if (optionsRequired.unassign) this.userIsSet = false;
      else this.userIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderFullTrackedI {
    const cloned = {} as OrderFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.orderSourceIsSetDeep() &&
      this.orderSourceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderSourceIsSet = true;
      cloned.orderSource = this.orderSource;
    } else {
      //cloned.orderSourceIsSet = false
    }
    if (
      this.amountSubtotalCentsIsSetDeep() &&
      this.amountSubtotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountSubtotalCentsIsSet = true;
      cloned.amountSubtotalCents = this.amountSubtotalCents;
    } else {
      //cloned.amountSubtotalCentsIsSet = false
    }
    if (
      this.amountDiscountsCentsIsSetDeep() &&
      this.amountDiscountsCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountDiscountsCentsIsSet = true;
      cloned.amountDiscountsCents = this.amountDiscountsCents;
    } else {
      //cloned.amountDiscountsCentsIsSet = false
    }
    if (
      this.amountTaxesCentsIsSetDeep() &&
      this.amountTaxesCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTaxesCentsIsSet = true;
      cloned.amountTaxesCents = this.amountTaxesCents;
    } else {
      //cloned.amountTaxesCentsIsSet = false
    }
    if (
      this.amountTotalCentsIsSetDeep() &&
      this.amountTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTotalCentsIsSet = true;
      cloned.amountTotalCents = this.amountTotalCents;
    } else {
      //cloned.amountTotalCentsIsSet = false
    }
    if (
      this.amountPaidCentsIsSetDeep() &&
      this.amountPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPaidCentsIsSet = true;
      cloned.amountPaidCents = this.amountPaidCents;
    } else {
      //cloned.amountPaidCentsIsSet = false
    }
    if (
      this.versionIsSetDeep() &&
      this.versionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.versionIsSet = true;
      cloned.version = this.version;
    } else {
      //cloned.versionIsSet = false
    }
    if (
      this.orderStatusIsSetDeep() &&
      this.orderStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderStatusIsSet = true;
      cloned.orderStatus = this.orderStatus;
    } else {
      //cloned.orderStatusIsSet = false
    }
    if (
      this.squareOrderIdIsSetDeep() &&
      this.squareOrderIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squareOrderIdIsSet = true;
      cloned.squareOrderId = this.squareOrderId;
    } else {
      //cloned.squareOrderIdIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.lineItemsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.lineItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lineItemsIsSet = true;
      cloned.lineItems = this.lineItems
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.lineItemsIsSet = false
    }
    if (
      this.orderPaymentsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.orderPaymentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderPaymentsIsSet = true;
      cloned.orderPayments = this.orderPayments
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.orderPaymentsIsSet = false
    }
    if (
      this.userIsSetDeep() &&
      this.userApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.userIsSet = true;
      cloned.user = this.user?.removeUnset(filter);
    } else {
      //cloned.userIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.orderSourceApplyFilter(filter)) this.orderSourceIsSet = false;

    if (!this.amountSubtotalCentsApplyFilter(filter))
      this.amountSubtotalCentsIsSet = false;

    if (!this.amountDiscountsCentsApplyFilter(filter))
      this.amountDiscountsCentsIsSet = false;

    if (!this.amountTaxesCentsApplyFilter(filter))
      this.amountTaxesCentsIsSet = false;

    if (!this.amountTotalCentsApplyFilter(filter))
      this.amountTotalCentsIsSet = false;

    if (!this.amountPaidCentsApplyFilter(filter))
      this.amountPaidCentsIsSet = false;

    if (!this.versionApplyFilter(filter)) this.versionIsSet = false;

    if (!this.orderStatusApplyFilter(filter)) this.orderStatusIsSet = false;

    if (!this.squareOrderIdApplyFilter(filter)) this.squareOrderIdIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.lineItemsApplyFilter(filter)) this.lineItemsIsSet = false;

    this.lineItems?.forEach((a) => a.unassignAll(filter));
    if (!this.orderPaymentsApplyFilter(filter)) this.orderPaymentsIsSet = false;

    this.orderPayments?.forEach((a) => a.unassignAll(filter));
    if (!this.userApplyFilter(filter)) this.userIsSet = false;
    this.user?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderFullMeta.isDeleted, OrderFullMeta, this.isDeleted, this);
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderFullMeta.isNew, OrderFullMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderFullMeta.assignId, OrderFullMeta, this.assignId, this);
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  orderSourceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderFullMeta.orderSource,
      OrderFullMeta,
      this.orderSource,
      this,
    );
  }
  orderSourceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderSourceIsSet && this.orderSourceApplyFilter(filter))
      return true;

    return false;
  }
  amountSubtotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderFullMeta.amountSubtotalCents,
      OrderFullMeta,
      this.amountSubtotalCents,
      this,
    );
  }
  amountSubtotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountSubtotalCentsIsSet &&
      this.amountSubtotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountDiscountsCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderFullMeta.amountDiscountsCents,
      OrderFullMeta,
      this.amountDiscountsCents,
      this,
    );
  }
  amountDiscountsCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountDiscountsCentsIsSet &&
      this.amountDiscountsCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountTaxesCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderFullMeta.amountTaxesCents,
      OrderFullMeta,
      this.amountTaxesCents,
      this,
    );
  }
  amountTaxesCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTaxesCentsIsSet && this.amountTaxesCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderFullMeta.amountTotalCents,
      OrderFullMeta,
      this.amountTotalCents,
      this,
    );
  }
  amountTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTotalCentsIsSet && this.amountTotalCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderFullMeta.amountPaidCents,
      OrderFullMeta,
      this.amountPaidCents,
      this,
    );
  }
  amountPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountPaidCentsIsSet && this.amountPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  versionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderFullMeta.version, OrderFullMeta, this.version, this);
  }
  versionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.versionIsSet && this.versionApplyFilter(filter)) return true;

    return false;
  }
  orderStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderFullMeta.orderStatus,
      OrderFullMeta,
      this.orderStatus,
      this,
    );
  }
  orderStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderStatusIsSet && this.orderStatusApplyFilter(filter))
      return true;

    return false;
  }
  squareOrderIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderFullMeta.squareOrderId,
      OrderFullMeta,
      this.squareOrderId,
      this,
    );
  }
  squareOrderIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.squareOrderIdIsSet && this.squareOrderIdApplyFilter(filter))
      return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderFullMeta.personId, OrderFullMeta, this.personId, this);
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  lineItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderFullMeta.lineItems, OrderFullMeta, this.lineItems, this);
  }
  lineItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lineItemsIsSet && this.lineItemsApplyFilter(filter)) return true;

    return this.lineItems?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  orderPaymentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderFullMeta.orderPayments,
      OrderFullMeta,
      this.orderPayments,
      this,
    );
  }
  orderPaymentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderPaymentsIsSet && this.orderPaymentsApplyFilter(filter))
      return true;

    return this.orderPayments?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  userApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(OrderFullMeta.user, OrderFullMeta, this.user, this);
  }
  userIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.userIsSet && this.userApplyFilter(filter)) return true;
    return this.user?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.orderSourceIsSetDeep(filter)) return true;
    if (this.amountSubtotalCentsIsSetDeep(filter)) return true;
    if (this.amountDiscountsCentsIsSetDeep(filter)) return true;
    if (this.amountTaxesCentsIsSetDeep(filter)) return true;
    if (this.amountTotalCentsIsSetDeep(filter)) return true;
    if (this.amountPaidCentsIsSetDeep(filter)) return true;
    if (this.versionIsSetDeep(filter)) return true;
    if (this.orderStatusIsSetDeep(filter)) return true;
    if (this.squareOrderIdIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.lineItemsIsSetDeep(filter)) return true;
    if (this.orderPaymentsIsSetDeep(filter)) return true;
    if (this.userIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
